import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { triggerNotification } from "../../component/message/Msg";
import config from "../../config";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import Rating from "../../component/rating/Rating";
import StarRatings from "react-star-ratings";
import Swal from "sweetalert2";

const ViewPackage = () => {
  const { id, cfa } = useParams();
  const { token, user_type, host_url } = config;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  //----------------------------------------------- manage states -----------------------------------------------
  const [packageDetails, setPackageDetails] = useState({});

  //----------------------------------------------- select / get / view package  -------------------------------------------------R
  const getPackage = async () => {
    setLoading(true);
    try {
      await fetch(`${host_url}packages/${decodeURIComponent(atob(id))}`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then(async (data) => {
          if (data.status === 200) {
            setPackageDetails(data.data);
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching package.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (id !== undefined) {
      getPackage();
    }
  }, [id]);

  // ------------------------------------------------- Edit / Update Plan ---------------------------------------------------- U
  const btnEditHandle = (pid) => {
    const encodedId = window.btoa(encodeURIComponent(pid));
    navigate(`/addplan/packageid/${id}/${encodedId}`);
  };

  // ---------------------------------------------------- Delete plan ---------------------------------------------------------D
  // Show a confirmation dialog
  const btnDeletePlanHandle = (deleteId, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete plan. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeletePlan(deleteId, i);
      }
    });
  };
  //If confirm then delete plan
  const handleDeletePlan = async (deleteId, i) => {
    try {
      await fetch(`${host_url}plans/${deleteId}?from=1`, {
        method: "DELETE",
        headers: {
          token: token,
        },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status === 200) {
            triggerNotification("success", "Plan deleted successfully");
            const updatedPlans = [...packageDetails.plans];
            updatedPlans.splice(i, 1);
            setPackageDetails((prevPackageDetail) => ({
              ...prevPackageDetail,
              plans: updatedPlans,
            }));
          } else if (data.status === 404) {
            // plan IDs Not Found
            console.error("Plan ID is not found");
            triggerNotification("error", "plan ID is not found");
          } else if (data.status === 401) {
            // Invalid Token
            console.error("Invalid token");
            triggerNotification("error", "Unauthenticated User");
          } else {
            // Internal Server Error or other HTTP errors
            console.error("Internal server error");
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      console.error("Error deleting plan:", error);
      triggerNotification("error", "Error deleting plan");
    }
  };

  return (
    <>
      <Breadcrumb
        txt="Manage Package"
        subpath={["View Packages", "Package Details"]}
        url={["/viewpackages"]}
      />

      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-body row g-3">
            {loading ? (
              <Spinner />
            ) : (
              <div className="col-lg-12">
                <div className="d-flex justify-content-between align-items-center flex-wrap mb-2 gap-1">
                  <div className=" flex">
                    <img
                      className="avatar rounded-full "
                      src={packageDetails.pkg_display_icon}
                      alt="Package Icon"
                    />
                    <h5 className="ml-3 my-auto">{packageDetails.pkg_name}</h5>
                  </div>
                </div>
                <div className="card academy-content shadow-none border">
                  <div className="p-2">
                    <div className="cursor-pointer">
                      <img
                        className="w-100 h-96 rounded"
                        src={packageDetails.pkg_display_image}
                        alt="package image"
                      />
                    </div>
                  </div>
                  <div className="card-body">
                    {/* About this package */}
                    <h5 className="mb-2">About this package</h5>
                    <p className="mb-0 pt-1">{packageDetails.demo_content}</p>

                    {/* Details */}
                    <hr className="my-4" />
                    <h5>Details</h5>
                    <div className=" table-responsive">
                      <table>
                        <tbody>
                          <tr>
                            <td>
                              <div className="me-5">
                                <p className="text-nowrap">
                                  <i
                                    className={`${config.tag_outline_icon} mdi-24px me-2`}
                                  ></i>
                                  Package Catagory Name :{" "}
                                  {packageDetails.pkg_catagory_name}
                                </p>
                              </div>
                            </td>
                            <td>
                              <div className="me-5">
                                <p className="text-nowrap">
                                  <i
                                    className={`${config.arrow_up_box_outline_icon} mdi-24px me-2`}
                                  ></i>
                                  Priority : {packageDetails.pkg_priority}
                                </p>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="me-5">
                                <p className="text-nowrap">
                                  <i
                                    className={`${config.package_variant_icon} mdi-24px me-2`}
                                  ></i>
                                  Type : {packageDetails.pkg_type}
                                </p>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* Plan */}
                    <hr className="my-4" />
                    {packageDetails.plans &&
                      packageDetails.plans.length > 0 && (
                        <>
                          <div className="flex justify-between items-center mb-3 mt-2">
                            <h5 className="p-0 m-0 inline-block align-baseline">
                              Plans
                            </h5>
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() =>
                                navigate(`/addplan/packageid/${id}`)
                              }
                            >
                              Add Plan
                            </button>
                          </div>

                          <div className=" table-responsive">
                            <table className="table table-bordered select-none">
                              <thead>
                                <tr>
                                  <th>Plan</th>
                                  <th>Duration </th>
                                  <th>Price </th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {packageDetails.plans &&
                                  packageDetails.plans.map((plan, i) => (
                                    <tr
                                      key={plan.pkg_price_id}
                                      className="select-none"
                                    >
                                      <td className="align-top col-sm-2 ">
                                        {i + 1}
                                      </td>
                                      <td className="align-top col-sm-2 ">
                                        {plan.pkg_plan_for +
                                          " " +
                                          plan.pkg_plan_unit}
                                      </td>
                                      <td className="align-top col-sm-2 ">
                                        {plan.promotional_price ? (
                                          <div className="">
                                            <small>
                                              <del>{plan.price}</del>
                                            </small>
                                            <p>{plan.promotional_price}</p>
                                          </div>
                                        ) : (
                                          plan.price
                                        )}
                                      </td>
                                      <td className="align-top col-sm-2 ">
                                        <button
                                          type="button"
                                          className="btn btn-icon btn-secondary m-2"
                                          onClick={() => {
                                            btnEditHandle(plan.pkg_price_id);
                                          }}
                                        >
                                          <span className="tf-icons mdi mdi-pencil"></span>
                                        </button>

                                        <button
                                          type="button"
                                          className="btn btn-icon btn-danger m-2"
                                          onClick={() => {
                                            btnDeletePlanHandle(
                                              plan.pkg_price_id,
                                              i
                                            );
                                          }}
                                        >
                                          <span className="tf-icons mdi mdi-delete"></span>
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </>
                      )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewPackage;
